import React, { ReactElement } from 'react'
import { deleteIcon } from '../../assets/images/images'
import { ICard } from '../../interfaces/Card'

const Card = ({
  children,
  removeCard,
  index,
  canBeDeleted,
}: ICard): ReactElement => {
  return (
    <div className="card mb4 mb55md">
      {canBeDeleted && (
        <div className="textRight">
          <span
            className="pointer dInlineBlock py15 px2 btnUnstyled mb15"
            onClick={() => removeCard(index)}
          >
            <img src={deleteIcon} alt="deleteCard" className="dBlock" />
          </span>
        </div>
      )}
      <div className="cardContent px25 py25">{children}</div>
    </div>
  )
}

export default Card
